import { type MaybeRefOrGetter, toValue } from "vue";

import i18n from "@/plugins/i18n";
import { OrderStopTypeMap } from "@/constants/order";
import { isBolSigned } from "@/utils/bol";

import type { DeleteBolValidationContext, DisableRule } from "@/types/validation";

const t = i18n.global.t;

export function useBols() {
  function createDeleteBolDisableRules(context: MaybeRefOrGetter<DeleteBolValidationContext>): DisableRule[] {
    const { bol, routeStop, routeStops } = toValue(context);

    if (!bol) {
      return [];
    }

    const bolRouteStop = routeStops.find((stop) => stop.id && stop.id === bol.routeStopId);
    const reusedReason = bolRouteStop
      ? t("trip.bol-reused-at-stop", {
          number: bol.number,
          stop: `${OrderStopTypeMap[bolRouteStop.type]} #${bolRouteStop.number}`,
        })
      : t("trip.bol-reused-at-another-stop", { number: bol.number });

    return [
      {
        disabled: bol.routeStopId !== routeStop.id,
        reasons: [reusedReason],
      },
      {
        disabled: isBolSigned(bol),
        reasons: [t("trip.bol-signed-on-delivery", { number: bol.number })],
      },
    ];
  }

  return { createDeleteBolDisableRules };
}
